import { cva as e } from "class-variance-authority";
// src/design/alert/style.ts
var t = e("relative w-full rounded-lg border flex items-start gap-2 transition-colors", {
	variants: {
		variant: {
			"subtle-info": "bg-info/10 border-none text-info-text",
			"subtle-success": "bg-success/10 border-none text-success-text",
			"subtle-warning": "bg-warning/10 border-none text-warning-text",
			"subtle-danger": "bg-destructive/10 border-none text-destructive-text",
			"subtle-default": "bg-muted border-none text-foreground",
			"solid-info": "bg-info border-info text-primary-foreground",
			"solid-success": "bg-success border-success text-primary-foreground",
			"solid-warning": "bg-warning border-warning text-primary-foreground",
			"solid-danger": "bg-destructive border-destructive text-primary-foreground",
			"solid-default": "bg-muted-foreground border-muted-foreground text-primary-foreground",
			"outline-info": "bg-card border-info text-info-text",
			"outline-success": "bg-card border-success text-success-text",
			"outline-warning": "bg-card border-warning text-warning-text",
			"outline-danger": "bg-card border-destructive text-destructive-text",
			"outline-default": "bg-card border-primary text-foreground",
			"left-accent-info": "bg-card border-l-4 border-info border-y-border border-r-border text-foreground",
			"left-accent-success": "bg-card border-l-4 border-success border-y-border border-r-border text-foreground",
			"left-accent-warning": "bg-card border-l-4 border-warning border-y-border border-r-border text-foreground",
			"left-accent-danger": "bg-card border-l-4 border-destructive border-y-border border-r-border text-foreground",
			"left-accent-default": "bg-card border-l-4 border-muted-foreground border-y-border border-r-border text-foreground"
		},
		size: {
			sm: "px-2 py-1.5 text-label",
			md: "px-2.5 py-2 text-sm",
			lg: "px-3 py-2.5 text-base"
		}
	},
	defaultVariants: {
		variant: "subtle-info",
		size: "md"
	}
}), n = e("shrink-0 mt-0.5", {
	variants: {
		size: {
			sm: "w-4 h-4",
			md: "w-5 h-5",
			lg: "w-6 h-6"
		},
		colorScheme: {
			info: "text-info-text",
			success: "text-success-text",
			warning: "text-warning-text",
			danger: "text-destructive-text",
			default: "text-foreground"
		},
		variant: {
			subtle: "",
			solid: "text-primary-foreground",
			outline: "",
			"left-accent": ""
		}
	},
	compoundVariants: [{
		variant: "solid",
		className: "text-primary-foreground"
	}],
	defaultVariants: {
		size: "md",
		colorScheme: "info",
		variant: "subtle"
	}
}), r = e("flex-1 min-w-0", {
	variants: { size: {
		sm: "gap-0",
		md: "gap-0.5",
		lg: "gap-1"
	} },
	defaultVariants: { size: "md" }
}), i = e("font-semibold", {
	variants: {
		size: {
			sm: "text-sm",
			md: "text-sm",
			lg: "text-base"
		},
		variant: {
			subtle: "",
			solid: "text-primary-foreground",
			outline: "",
			"left-accent": ""
		}
	},
	defaultVariants: {
		size: "md",
		variant: "subtle"
	}
}), a = e("mt-0.5 leading-snug [&_ul]:leading-snug [&_ol]:leading-snug [&_li]:leading-snug", {
	variants: {
		size: {
			sm: "text-xs",
			md: "text-sm",
			lg: "text-sm"
		},
		variant: {
			subtle: "text-current opacity-90",
			solid: "text-primary-foreground opacity-90",
			outline: "text-current opacity-90",
			"left-accent": "text-muted-foreground"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "subtle"
	}
}), o = e("shrink-0 rounded-md p-1 transition-colors mt-0.5 focus-ring", {
	variants: {
		size: {
			sm: "p-0.5",
			md: "p-1",
			lg: "p-1.5"
		},
		variant: {
			subtle: "hover:bg-black/5 dark:hover:bg-white/10",
			solid: "hover:bg-white/20 dark:hover:bg-black/20 text-primary-foreground focus-visible:outline-current",
			outline: "hover:bg-black/5 dark:hover:bg-white/10",
			"left-accent": "hover:bg-black/5 dark:hover:bg-white/10"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "subtle"
	}
}), s = e("flex items-center gap-2 mt-3", {
	variants: { size: {
		sm: "gap-1.5 mt-2",
		md: "gap-2 mt-3",
		lg: "gap-2.5 mt-4"
	} },
	defaultVariants: { size: "md" }
});
function c(e) {
	let c = e?.variant || "subtle", l = e?.colorScheme || "info", u = e?.size || "md", d = `${c}-${l}`;
	return {
		root: () => t({
			variant: d,
			size: u
		}),
		icon: () => n({
			size: u,
			colorScheme: l,
			variant: c
		}),
		content: () => r({ size: u }),
		title: () => i({
			size: u,
			variant: c
		}),
		description: () => a({
			size: u,
			variant: c
		}),
		closeButton: () => o({
			size: u,
			variant: c
		}),
		actions: () => s({ size: u })
	};
}
export { s as alertActionsStyles, o as alertCloseButtonStyles, r as alertContentStyles, a as alertDescriptionStyles, n as alertIconStyles, t as alertRootStyles, i as alertTitleStyles, c as getStyles };

//# sourceMappingURL=style.js.map